import React from 'react';

export default function Finansal() {
  return (
    <div>
      <div className="page-header">
        <h1>📊 Finansal Tanımlar</h1>
        <p>Gelir tanımları ve finansal kategori yönetimi.</p>
      </div>
      <div className="card" style={{ textAlign: 'center', padding: 60, color: '#888' }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>📊</div>
        <div style={{ fontSize: 14 }}>Finansal Tanımlar modülü yapım aşamasında.</div>
      </div>
    </div>
  );
}
